import Auth from '../../modules/Authentication'
import { formatQueryParams, handleErrors, handleResponse } from '../../modules/Utils'
import { apiUrl } from '../../variables/index'

const headers = {}

export default class Accounts {
  auth = new Auth()
  list = (company, center, parentName) => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}accounts?select=${select}${formatQueryParams('company', company)}${formatQueryParams(
        'center',
        center
      )}${formatQueryParams('parentName', parentName)}`,
      {
        headers: headers,
        method: 'GET',
      }
    )
      .then(handleErrors)
      .then(handleResponse)
  }
}
